import QuickLinksImpl from './quick-links.js';
import MojitoCore from 'mojito/core';

/**
 * QuickLinksController module.
 *
 * @class QuickLinks
 * @name module
 * @memberof Mojito.Modules.QuickLinks
 */

export default MojitoCore.Presentation.UIView('QuickLinks', QuickLinksImpl);
